module.exports = __webpack_public_path__ + "static/media/jeanyvescharlier.6a827442.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/jeanyvescharlier.webp
// module id = 599
// module chunks = 0